import {
  IsRadioOrCheckboxGroupElementSymbol,
  RadioGroupInput
} from '@framework/form';
import React from 'react';
import { SelectListOption } from '../../common/option-list/SelectListOption';
import { getWidgetProps } from '../../common/util/getWidgetProps';
import { ISingleSelectWidgetComponentProps } from '../SingleSelectWidgetComponent';
import { IUseSingleSelectWidgetOptionsReturn } from '../hooks/useSingleSelectWidgetOptions';
import { SingleSelectOption } from './SingleSelectOption';

export interface ISingleSelectRadioComponentProps
  extends ISingleSelectWidgetComponentProps,
    IUseSingleSelectWidgetOptionsReturn {}

export function SingleSelectRadioComponent(
  props: ISingleSelectRadioComponentProps,
) {
  const { widget, componentOptions } = props;
  const widgetOptions = getWidgetProps(props);

  return (
    <RadioGroupInput
      name={widgetOptions.name}
      vertical={widget.layout?.direction === 'vertical'}
      readOnly={props.readonly}
    >
      <SelectListOption
        readonly={props.readonly}
        widget={widget}
        options={componentOptions}
        OptionComponent={SingleSelectOption}
        widgetOptions={widgetOptions}
      />
    </RadioGroupInput>
  );
}

SingleSelectRadioComponent[IsRadioOrCheckboxGroupElementSymbol] = true;
